<template>
  <pagefra>
    <div
      class="lift container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('大楼名称')">
              <el-input
                v-model="form.buildingName"
                :placeholder="$l('大楼名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('注册代码')">
              <el-input
                v-model="form.registerCode"
                :placeholder="$l('注册代码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('电梯类型')">
              <el-select
                v-model="form.elevatorType"
                :placeholder="$l('电梯类型')"
              >
                <el-option :label="$l('电梯类型')" value></el-option>
                <el-option :label="$l('直梯')" value="直梯"></el-option>
                <el-option :label="$l('扶梯')" value="扶梯"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$l('电梯管理员')">
              <el-input
                v-model="form.adminName"
                :placeholder="$l('电梯管理员')"
              ></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$l('报告状态')">
              <el-select
                v-model="form.reportStatus"
                :placeholder="$l('报告状态')"
              >
                <el-option :label="$l('全部')" value="0"></el-option>
                <el-option :label="$l('已确认')" value="1"></el-option>
                <el-option :label="$l('未确认')" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('巡检时间')">
              <el-date-picker
                v-model="planStartTimeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              icon="el-icon-date"
              type="primary"
              round
              @click="handleWeeklyOrMonthly(1)"
              v-show="hasPermission('周报')"
              >{{ $l("周报") }}
            </el-button>
            <el-button
              icon="el-icon-date"
              type="primary"
              round
              @click="handleWeeklyOrMonthly(2)"
              v-show="hasPermission('月报')"
              >{{ $l("月报") }}
            </el-button>
            <el-button
              icon="el-icon-edit"
              type="primary"
              :loading="batchLoading"
              round
              @click="showBatch"
              v-show="hasPermission('日报')"
              >{{ $l("一键生成日报") }}
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-s-tools"
              round
              @click="showSetting"
              v-show="hasPermission('指标项设置')"
              >{{ $l("指标项设置") }}
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-document-add"
              round
              @click="showWhiteList"
              v-show="hasPermission('安全员名单')"
              >{{ $l("安全员名单") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            @selection-change="selectChange"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
              :formatter="cityFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯类型')"
              prop="elevatorType"
              align="center"
              min-width="120"
              :formatter="elevatorTypeFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('注册代码')"
              prop="registerCode"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('报告列表')"
              min-width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <svgicon
                  name="report"
                  class="report-list-icon"
                  @click="showReportList(scope.row)"
                ></svgicon>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="reportType == 1 ? $l('查看周报') : $l('查看月报')"
        :visible.sync="weeklyVisible"
        width="20%"
      >
        <el-date-picker
          style="width: 100%"
          value-format="yyyy-MM-dd"
          v-model="weeklyMonthlyValue"
          :type="reportType == 1 ? 'week' : 'month'"
          :format="reportType == 1 ? weeklyMonthly : 'yyyy年MM月'"
          :placeholder="reportType == 1 ? $l('选择周') : $l('选择月')"
          :picker-options="reportType == 1 ? weekPickerOptions : pickerOptions"
          @change="handleWeekChange"
        >
        </el-date-picker>
        <div slot="footer" class="dialog-footer">
          <el-button @click="weeklyVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="clickViewWeekly"
            >{{ $l("查看") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('一键生成日报')"
        :visible.sync="batchVisible"
        width="420px"
        :close-on-click-modal="false"
        @closed="
          isReportListBatch = false;
          showBatchDateRange = true;
          reportListSelectedRows = [];
          reportListDateList = [];
        "
      >
        <div class="batch-form">
          <el-form :model="batchForm" label-width="90px">
            <el-form-item
              v-if="showBatchDateRange"
              :label="$l('日期范围')"
              required
            >
              <el-date-picker
                v-model="batchDateRange"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始日期')"
                :end-placeholder="$l('结束日期')"
                value-format="yyyy-MM-dd"
                style="width: 260px"
                :picker-options="pickerOptions"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$l('巡检人员')"
              class="sign-form-item"
              required
            >
              <div class="sign-display">
                <img v-if="signatureImg" :src="signatureImg" class="sign-img" />
                <el-button
                  v-if="signatureImg"
                  type="text"
                  size="mini"
                  class="sign-btn"
                  @click="signVisible = true"
                  >重新签名</el-button
                >
                <el-button
                  v-else
                  type="primary"
                  round
                  size="mini"
                  @click="signVisible = true"
                  >{{ $l("签名") }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchVisible = false">{{
            $l("取 消")
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            @click="batchSubmit"
            :loading="batchLoading"
            >{{ $l("提 交") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('报告列表')"
        :visible.sync="reportListVisible"
        width="960px"
        @opened="getReportList"
      >
        <div class="report-list-filter">
          <el-form :inline="true" :model="reportListForm" label-width="100px">
            <el-form-item :label="$l('报告状态')">
              <el-select
                v-model="reportListForm.reportStatus"
                :placeholder="$l('请选择')"
                clearable
                style="width: 150px"
              >
                <el-option :label="$l('全部')" value=""></el-option>
                <el-option :label="$l('未确认')" value="0"></el-option>
                <el-option :label="$l('草稿')" value="1"></el-option>
                <el-option :label="$l('已确认')" value="２"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('确认时间')">
              <el-date-picker
                v-model="reportListForm.dateRange"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                circle
                @click="searchReportList"
              ></el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-edit"
                type="primary"
                :loading="batchLoading"
                round
                size="small"
                @click="showReportListBatch"
                v-show="hasPermission('日报')"
                >{{ $l("一键生成日报") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :data="reportListData"
          style="width: 100%"
          v-loading="reportListLoading"
          @selection-change="reportListSelectionChange"
        >
          <el-table-column type="selection" align="center" min-width="55">
          </el-table-column>
          <el-table-column
            :label="$l('报告状态')"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.reportId ? '#30c9c9' : '#df4545' }"
              >
                {{
                  scope.row.reportId
                    ? scope.row.reportStatus == 1
                      ? $l("草稿")
                      : $l("已确认")
                    : $l("未确认")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('确认时间')"
            align="center"
            min-width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.confirmTime }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$l('查看日报')"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <svgicon
                name="ribao"
                class="report-list-icon"
                @click="handleReportListDaily(scope.row)"
              ></svgicon>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-pagination">
          <el-pagination
            :current-page="reportListPageConfig.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="reportListPageConfig.pageSize"
            :total="reportListPageConfig.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleReportListPageSizeChange"
            @current-change="handleReportListCurrentPageChange"
          >
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('指标项设置')"
        :visible.sync="setVisible"
        width="800px"
        :close-on-click-modal="false"
      >
        <div class="setting-toolbar">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="handleSettingAdd"
            >{{ $l("新增") }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="handleSettingEdit"
            >{{ $l("修改") }}
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="handleSettingDelete"
            >{{ $l("删除") }}
          </el-button>
        </div>
        <el-tabs v-model="settingActiveTab" v-loading="settingLoading">
          <el-tab-pane :label="$l('直梯')" name="elevator">
            <div style="max-height: 500px; overflow-y: auto">
              <el-tree
                :key="'setting-tree-elevator-' + settingTreeKey"
                ref="elevatorTree"
                :data="elevatorTreeData"
                :props="settingTreeProps"
                node-key="id"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                @node-click="(data) => handleSettingNodeClick('elevator', data)"
              >
                <span slot-scope="{ node }">{{ $l(node.data.name) }}</span>
              </el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$l('扶梯')" name="escalator">
            <div style="max-height: 500px; overflow-y: auto">
              <el-tree
                :key="'setting-tree-escalator-' + settingTreeKey"
                ref="escalatorTree"
                :data="escalatorTreeData"
                :props="settingTreeProps"
                node-key="id"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                @node-click="
                  (data) => handleSettingNodeClick('escalator', data)
                "
              >
                <span slot-scope="{ node }">{{ $l(node.data.name) }}</span>
              </el-tree>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button @click="setVisible = false">{{ $l("取 消") }} </el-button>
          <el-button
            type="primary"
            :loading="settingSaveLoading"
            @click="saveSetting"
            >{{ $l("保 存") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="settingFormMode === 'add' ? $l('新增指标项') : $l('修改指标项')"
        :visible.sync="settingFormVisible"
        width="640px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form
          ref="settingForm"
          :model="settingForm"
          :rules="settingFormRules"
          label-width="90px"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$l('名称')" prop="name">
                <el-input
                  v-model="settingForm.name"
                  :placeholder="$l('请输入名称')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('类型')" prop="type">
                <el-select
                  v-model="settingForm.type"
                  style="width: 100%"
                  disabled
                >
                  <el-option :label="$l('标题')" value="title"></el-option>
                  <el-option :label="$l('指标项')" value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="settingForm.type !== 'title'">
              <el-form-item :label="$l('指标值')" prop="value">
                <el-input
                  v-model="settingForm.value"
                  :placeholder="$l('请输入指标值')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="settingForm.type !== 'title'">
              <el-form-item :label="$l('单位')" prop="unit">
                <el-input
                  v-model="settingForm.unit"
                  :placeholder="$l('如：台、件')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="settingForm.type !== 'title'">
              <el-form-item :label="$l('默认值')" prop="defaultValue">
                <el-input
                  v-model="settingForm.defaultValue"
                  :placeholder="$l('请输入默认值')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="settingForm.type !== 'title'">
              <el-form-item :label="$l('组件类型')" prop="vType">
                <el-select
                  v-model="settingForm.vType"
                  style="width: 100%"
                  clearable
                  @change="handleSettingVTypeChange"
                >
                  <el-option
                    :label="$l('文本输入框')"
                    value="input"
                  ></el-option>
                  <el-option :label="$l('下拉框')" value="select"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              v-if="
                settingForm.type !== 'title' && settingForm.vType === 'select'
              "
            >
              <el-form-item :label="$l('下拉数据')" prop="vList">
                <el-table :data="settingVList" border style="width: 100%">
                  <el-table-column :label="$l('名称')" min-width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.name"
                        :placeholder="$l('请输入名称')"
                        size="small"
                        @change="validateSettingVListField"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$l('值')" min-width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.value"
                        :placeholder="$l('请输入值')"
                        size="small"
                        @change="validateSettingVListField"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$l('操作')"
                    width="70"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        icon="el-icon-minus"
                        @click="removeSettingVListRow(scope.$index)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  circle
                  size="small"
                  style="margin-top: 10px"
                  @click="addSettingVListRow"
                ></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="settingForm.type !== 'title'">
              <el-form-item :label="$l('默认值来源')" prop="code">
                <el-select
                  v-model="settingForm.code"
                  :placeholder="$l('请选择默认值来源')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in settingCodeList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('排序')" prop="sort">
                <el-input
                  v-model="settingForm.sort"
                  :placeholder="$l('请输入排序')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('备注')" prop="remark">
                <el-input
                  v-model="settingForm.remark"
                  type="textarea"
                  :rows="2"
                  :placeholder="$l('请输入备注')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="settingFormVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="submitSettingForm"
            >{{ $l("确 定") }}
          </el-button>
        </div>
      </el-dialog>
      <sign-dialog
        ref="signDialog"
        :visible.sync="signVisible"
        @confirm="onSignConfirm"
      ></sign-dialog>
      <el-dialog
        :title="$l('安全员名单')"
        :visible.sync="whiteListVisible"
        width="600px"
      >
        <div style="max-height: 500px; overflow-y: auto">
          <el-table :data="whiteListData" border style="width: 100%">
            <el-table-column :label="$l('用户名')" min-width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.userName"
                  :placeholder="$l('请输入用户名')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$l('手机号')" min-width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.telNum"
                  :placeholder="$l('请输入手机号')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$l('操作')" width="80" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="whiteListData.length > 1"
                  type="text"
                  icon="el-icon-minus"
                  @click="removeWhiteListRow(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            style="margin-top: 10px"
            @click="addWhiteListRow"
          ></el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="whiteListVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button
            type="primary"
            @click="saveWhiteList"
            :loading="whiteListLoading"
            >{{ $l("保存") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
import dayjs from "dayjs";
import signDialog from "@/components/signDialog.vue";
function createDefaultSettingVList() {
  return [
    { name: "正常", value: "正常" },
    { name: "异常", value: "异常" },
  ];
}
export default {
  name: "elevatorReport",
  mixins: [global],
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { jobNum, startTime, endTime } = to.query;
      if (jobNum || (startTime && endTime)) {
        vm.form.jobNum = jobNum || "";
        if (startTime && endTime) {
          vm.planStartTimeValues = [new Date(startTime), new Date(endTime)];
        } else {
          vm.planStartTimeValues = [];
        }
        vm.pageConfig.currentPage = 1;
        vm.$nextTick(() => {
          vm.initData();
        });
      } else {
        vm.form.jobNum = "";
        vm.planStartTimeValues = [new Date(), new Date()];
      }
    });
  },
  components: {
    panel,
    breadcrumb,
    signDialog,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const today = new Date().getTime();
          const selectedDate = time.getTime();
          return selectedDate > today;
        },
      },
      weekPickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(23, 59, 59, 999);
          return time.getTime() > today.getTime();
        },
        firstDayOfWeek: 1,
      },
      weeklyVisible: false,
      reportType: 0,
      weeklyMonthlyValue: "",
      row: {},
      date: "",
      form: {
        city: "",
        domainName: "",
        jobNum: "",
        registerCode: "",
        adminName: "",
        buildingName: "",
        dataPermissionList: [],
      },
      tableData: [],
      planStartTimeValues: [new Date(), new Date()],
      loading: false,
      fullLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (time) {
            return time.getTime() > new Date().getTime();
          }
        },
      },
      batchLoading: false,
      selectedList: [], //选中的行集合
      batchVisible: false,
      batchDateRange: [],
      isReportListBatch: false,
      showBatchDateRange: true,
      reportListSelectedRows: [],
      reportListDateList: [],
      batchForm: {},
      signatureImg: "",
      signVisible: false,
      reportListVisible: false,
      reportListData: [],
      reportListLoading: false,
      reportListPageConfig: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      reportListForm: {
        reportStatus: "",
        dateRange: [],
      },
      reportListRow: {},
      setVisible: false,
      settingActiveTab: "elevator",
      settingLoading: false,
      settingTreeProps: {
        children: "childrens",
        label: "name",
      },
      elevatorTreeData: [],
      escalatorTreeData: [],
      settingTreeKey: 0,
      settingCodeList: [],
      settingSelected: {
        tab: "",
        data: null,
      },
      settingFormVisible: false,
      settingFormMode: "add",
      settingEditData: null,
      settingForm: {
        name: "",
        type: "title",
        value: "",
        unit: "",
        defaultValue: "",
        vType: "",
        code: "",
        sort: 1,
        remark: "",
      },
      settingVList: createDefaultSettingVList(),
      settingSaveLoading: false,
      whiteListVisible: false,
      whiteListData: [],
      whiteListLoading: false,
    };
  },
  computed: {
    settingFormRules() {
      const isIndex = this.settingForm.type === "index";
      return {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        defaultValue: isIndex
          ? [{ required: true, message: "默认值不能为空", trigger: "blur" }]
          : [],
        vType: isIndex
          ? [{ required: true, message: "请选择组件类型", trigger: "change" }]
          : [],
        vList:
          isIndex && this.settingForm.vType === "select"
            ? [
                {
                  required: true,
                  validator: this.validateSettingVList,
                  trigger: "change",
                },
              ]
            : [],
      };
    },
    weeklyMonthly() {
      let end = dayjs(this.weeklyMonthlyValue)
        .add(6, "day")
        .format("YYYY年MM月DD日");
      return `${dayjs(this.weeklyMonthlyValue).format(
        "YYYY年MM月DD日"
      )} 至 ${end}`;
    },
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      if (!this.planStartTimeValues || this.planStartTimeValues.length !== 2) {
        this.message(1, this.$l("请选择开始和结束时间"));
        return;
      }
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    showReportList(row) {
      this.reportListRow = row;
      this.reportListSelectedRows = [];
      const today = dayjs().format("YYYY-MM-DD");
      this.reportListForm = {
        reportStatus: "",
        dateRange: [today, today],
      };
      this.reportListPageConfig.currentPage = 1;
      this.reportListVisible = true;
    },
    reportListSelectionChange(selection) {
      this.reportListSelectedRows = selection;
    },
    searchReportList() {
      if (
        !this.reportListForm.dateRange ||
        this.reportListForm.dateRange.length !== 2
      ) {
        this.message(1, "请选择确认时间范围");
        return;
      }
      this.reportListPageConfig.currentPage = 1;
      this.getReportList();
    },
    handleReportListPageSizeChange(val) {
      this.reportListPageConfig.pageSize = val;
      this.getReportList();
    },
    handleReportListCurrentPageChange(val) {
      this.reportListPageConfig.currentPage = val;
      this.getReportList();
    },
    getReportList() {
      this.reportListLoading = true;
      const params = {
        jobNum: this.reportListRow.jobNum || "",
        pageNum: this.reportListPageConfig.currentPage,
        pageSize: this.reportListPageConfig.pageSize,
        pageName: "lift",
        city: this.reportListRow.city || "",
        domainName: this.reportListRow.domainName || "",
      };
      if (this.reportListForm.reportStatus !== "") {
        params.reportStatus = this.reportListForm.reportStatus === "1" ? 1 : 0;
      }
      if (
        this.reportListForm.dateRange &&
        this.reportListForm.dateRange.length === 2
      ) {
        params.startDate = this.reportListForm.dateRange[0];
        params.endDate = this.reportListForm.dateRange[1];
      }
      this.$http
        .post(this.$apiConfig.get_inspection_report_list, params)
        .then((response) => {
          this.reportListLoading = false;
          let result = response.data;
          if (result.code === 0) {
            this.reportListPageConfig.total = result.data.total;
            result.data.result = result.data.result.map((item) => {
              item.confirmTime = this.$common.formatDate(item.confirmTime);
              return { ...item };
            });
            this.reportListData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.reportListLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleReportListDaily(row) {
      this.reportListVisible = false;
      sessionStorage.setItem("reportListDialogOpen", "true");
      this.$router.push({
        path: "/report/elevatorDaily",
        query: {
          reportId: row.reportId || "",
          jobNum: this.reportListRow.jobNum,
          confirmTime: row.confirmTime || this.$common.formatDate(new Date()),
        },
      });
    },
    handleReportListWeekly(row) {
      this.reportType = 1;
      this.row = this.reportListRow;
      this.weeklyMonthlyValue = dayjs()
        .startOf("week")
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.weeklyVisible = false;
      this.clickViewWeekly();
    },
    handleReportListMonthly(row) {
      this.reportType = 2;
      this.row = this.reportListRow;
      this.weeklyMonthlyValue = dayjs().format("YYYY-MM-01");
      this.weeklyVisible = false;
      this.clickViewWeekly();
    },
    initData(force) {
      this.selectedList = [];
      if (force) {
        this.form.pageNum = this.pageConfig.currentPage;
        this.form.pageSize = this.pageConfig.pageSize;
        this.form.pageName = "lift";
        this.tableData = [];
        this.loading = true;
        this.$http
          .post(this.$apiConfig.search_elevator_url, this.form)
          .then((response) => {
            this.loading = false;
            let result = response.data;
            if (result.code == 0) {
              this.pageConfig.total = result.data.total;
              this.tableData = result.data.result;
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
        return;
      }
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.form.pageName = "lift";
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleReportInfo(row) {
      this.$router.push({
        path: "/report/elevatorDaily",
        query: {
          reportId: row.reportId,
          jobNum: row.jobNum,
          confirmTime: row.confirmTime || this.$common.formatDate(new Date()),
        },
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    handleWeeklyOrMonthly(type) {
      const len = this.selectedList.length;
      if (len != 1) {
        this.message(1, "请选择一条数据");
        return;
      }
      this.reportType = type;
      this.row = this.selectedList[0];
      const firstDayOfWeek =
        type == 1
          ? dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-01");
      this.weeklyMonthlyValue = firstDayOfWeek;
      this.weeklyVisible = true;
    },
    handleWeekChange(val) {
      if (val && this.reportType == 1) {
        const date = new Date(val);
        const day = date.getDay();
        const diff = day === 0 ? -6 : 1 - day;
        const monday = new Date(date);
        monday.setDate(date.getDate() + diff);
        this.weeklyMonthlyValue = dayjs(monday).format("YYYY-MM-DD");
      }
    },
    clickViewWeekly() {
      let start = this.weeklyMonthlyValue;
      let end =
        this.reportType == 1
          ? dayjs(start).add(6, "day").format("YYYY-MM-DD")
          : dayjs(this.weeklyMonthlyValue).endOf("month").format("YYYY-MM-DD");
      const query = {
        reportType: this.reportType,
        jobNum: this.row.jobNum,
        startTime: start,
        endTime: end,
      };
      this.weeklyVisible = false;
      this.$router.push({
        path: this.reportType == 1 ? "/report/weekly" : "/report/monthly",
        query,
      });
    },
    showSetting() {
      this.setVisible = true;
      this.settingActiveTab = "elevator";
      this.settingSelected = { tab: "", data: null };
      this.settingLoading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_report_code)
        .then((response) => {
          this.settingLoading = false;
          let result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.elevatorTreeData = data.elevator || [];
            this.escalatorTreeData = data.escalator || [];
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.settingLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
      this.getCodeList();
    },
    getCodeList() {
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_code_list)
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            this.settingCodeList = result.data || [];
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    getSettingTreeData(tab) {
      return tab === "escalator"
        ? this.escalatorTreeData
        : this.elevatorTreeData;
    },
    getSettingTreeRef(tab) {
      return this.$refs[tab === "escalator" ? "escalatorTree" : "elevatorTree"];
    },
    handleSettingNodeClick(tab, data) {
      if (
        this.settingSelected.tab === tab &&
        this.settingSelected.data === data
      ) {
        this.settingSelected = { tab: "", data: null };
        const treeRef = this.getSettingTreeRef(tab);
        if (treeRef) {
          treeRef.setCurrentKey(null);
        }
        return;
      }
      this.settingSelected = { tab, data };
      const otherTreeRef = this.getSettingTreeRef(
        tab === "elevator" ? "escalator" : "elevator"
      );
      if (otherTreeRef) {
        otherTreeRef.setCurrentKey(null);
      }
    },
    getSettingNodeLevel(data) {
      const find = (arr, level) => {
        for (const item of arr) {
          if (item === data) {
            return level;
          }
          if (item.childrens && item.childrens.length > 0) {
            const found = find(item.childrens, level + 1);
            if (found) {
              return found;
            }
          }
        }
        return 0;
      };
      return find(this.getSettingTreeData(this.settingSelected.tab), 1);
    },
    handleSettingAdd() {
      this.settingFormMode = "add";
      this.settingEditData = null;
      const activeTab = this.settingActiveTab;
      const hasSelected =
        this.settingSelected.tab === activeTab && this.settingSelected.data;
      if (
        hasSelected &&
        this.getSettingNodeLevel(this.settingSelected.data) >= 2
      ) {
        return this.message(1, "只能添加两级节点");
      }
      const siblings = hasSelected
        ? this.settingSelected.data.childrens || []
        : this.getSettingTreeData(activeTab);
      this.resetSettingForm(
        siblings.length + 1,
        hasSelected ? "index" : "title"
      );
      this.settingFormVisible = true;
    },
    handleSettingEdit() {
      const selected = this.settingSelected;
      if (!selected.data) {
        return this.message(1, "请先选择一个节点");
      }
      const d = selected.data;
      this.settingFormMode = "edit";
      this.settingEditData = d;
      this.settingForm = {
        name: d.name || "",
        type: d.type || "index",
        value: d.value || "",
        unit: d.unit || "",
        defaultValue: d.defaultValue || "",
        vType: d.vType || "",
        code: d.code || "",
        sort: d.sort || 1,
        remark: d.remark || "",
      };
      this.settingVList = this.parseSettingVList(d.vList);
      this.settingFormVisible = true;
    },
    handleSettingDelete() {
      const selected = this.settingSelected;
      if (!selected.data) {
        return this.message(1, "请先选择一个节点");
      }
      this.$confirm(
        `确定删除节点“${selected.data.name}”及其子节点吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.removeSettingNode(selected.tab, selected.data);
        })
        .catch(() => {});
    },
    removeSettingNode(tab, data) {
      const treeRef = this.getSettingTreeRef(tab);
      if (treeRef) {
        treeRef.remove(data);
      }
      this.settingSelected = { tab: "", data: null };
    },
    handleSettingVTypeChange(val) {
      if (val === "select") {
        const firstRow = (this.settingVList || [])[0];
        if (!this.settingForm.defaultValue && firstRow && firstRow.name) {
          this.settingForm.defaultValue = firstRow.name;
        }
      }
      this.$nextTick(() => {
        if (!this.$refs.settingForm) {
          return;
        }
        if (val === "select") {
          this.$refs.settingForm.validateField("vList");
        } else {
          this.$refs.settingForm.clearValidate("vList");
        }
      });
    },
    /* 下拉数据校验：组件类型为下拉框时必须至少添加一条完整的下拉数据 */
    validateSettingVList(rule, value, callback) {
      if (
        this.settingForm.type !== "index" ||
        this.settingForm.vType !== "select"
      ) {
        return callback();
      }
      const rows = (this.settingVList || []).filter(
        (item) => item.name.trim() !== "" || item.value.trim() !== ""
      );
      if (rows.length === 0) {
        return callback(new Error("请添加下拉数据"));
      }
      const incomplete = rows.some(
        (item) => item.name.trim() === "" || item.value.trim() === ""
      );
      if (incomplete) {
        return callback(new Error("下拉数据的名称和值均不能为空"));
      }
      callback();
    },
    validateSettingVListField() {
      if (
        this.$refs.settingForm &&
        this.settingForm.type === "index" &&
        this.settingForm.vType === "select"
      ) {
        this.$refs.settingForm.validateField("vList");
      }
    },
    resetSettingForm(sort, type) {
      this.settingForm = {
        name: "",
        type: type || "title",
        value: "",
        unit: "",
        defaultValue: "",
        vType: "",
        code: "",
        sort: sort || 1,
        remark: "",
      };
      this.settingVList = createDefaultSettingVList();
      this.$nextTick(() => {
        if (this.$refs.settingForm) {
          this.$refs.settingForm.clearValidate();
        }
      });
    },
    generateSettingId() {
      return `${Date.now()}${Math.floor(Math.random() * 10000)}`;
    },
    parseSettingVList(str) {
      if (typeof str === "string" && str.trim()) {
        try {
          const list = JSON.parse(str);
          if (Array.isArray(list) && list.length > 0) {
            return list.map((item) => ({
              name: (item && item.name) || "",
              value: (item && item.value) || "",
            }));
          }
        } catch (e) {
          this.$sentry.captureException(e);
        }
      }
      return createDefaultSettingVList();
    },
    addSettingVListRow() {
      this.settingVList.push({ name: "", value: "" });
      this.validateSettingVListField();
    },
    removeSettingVListRow(index) {
      this.settingVList.splice(index, 1);
      this.validateSettingVListField();
    },
    submitSettingForm() {
      this.$refs.settingForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const form = this.settingForm;
        const vListRows =
          form.vType === "select"
            ? this.settingVList
                .filter(
                  (item) => item.name.trim() !== "" || item.value.trim() !== ""
                )
                .map((item) => ({
                  name: item.name.trim(),
                  value: item.value.trim(),
                }))
            : [];
        const nodeData = {
          type: form.type,
          name: form.name.trim(),
          value: form.value,
          unit: form.unit,
          defaultValue: form.defaultValue,
          vType: form.vType,
          vList: form.vType === "select" ? JSON.stringify(vListRows) : "",
          code: form.code,
          sort: Number(form.sort) || 1,
          remark: form.remark,
        };
        const activeTab = this.settingActiveTab;
        if (this.settingFormMode === "add") {
          const selected =
            this.settingSelected.tab === activeTab && this.settingSelected.data
              ? this.settingSelected
              : null;
          const newNode = {
            id: this.generateSettingId(),
            ...nodeData,
            childrens: [],
          };
          const treeRef = this.getSettingTreeRef(activeTab);
          if (treeRef) {
            treeRef.append(newNode, selected ? selected.data : null);
            if (selected) {
              const parentNode = treeRef.store.getNode(selected.data.id);
              if (parentNode) {
                parentNode.expanded = true;
              }
            }
          }
        } else {
          Object.assign(this.settingEditData, nodeData);
        }
        if (activeTab === "escalator") {
          this.escalatorTreeData = this.sortSettingTree(this.escalatorTreeData);
        } else {
          this.elevatorTreeData = this.sortSettingTree(this.elevatorTreeData);
        }
        this.settingTreeKey++;
        this.$nextTick(() => {
          const treeRef = this.getSettingTreeRef(activeTab);
          if (
            treeRef &&
            this.settingSelected.tab === activeTab &&
            this.settingSelected.data
          ) {
            treeRef.setCurrentKey(this.settingSelected.data.id);
          }
        });
        this.settingFormVisible = false;
      });
    },
    sortSettingTree(arr) {
      const sorted = [...arr].sort(
        (a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0)
      );
      for (const item of sorted) {
        if (item.childrens && item.childrens.length > 0) {
          item.childrens = this.sortSettingTree(item.childrens);
        }
      }
      return sorted;
    },
    saveSetting() {
      this.settingSaveLoading = true;
      const params = {
        elevatorJson: JSON.stringify(
          this.sortSettingTree(this.elevatorTreeData)
        ),
        escalatorJson: JSON.stringify(
          this.sortSettingTree(this.escalatorTreeData)
        ),
      };
      this.$http
        .post(this.$apiConfig.save_elevator_inspection_report_code, params)
        .then((response) => {
          this.settingSaveLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.$message.success("保存成功！");
            this.setVisible = false;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.settingSaveLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showBatch() {
      let list = this.selectedList;
      const len = list.length;
      if (len < 1) {
        this.message(1, "请选择数据");
        return;
      }
      this.isReportListBatch = false;
      this.showBatchDateRange = true;
      this.reportListSelectedRows = [];
      this.batchDateRange = [
        this.$common.formatDate(new Date()),
        this.$common.formatDate(new Date()),
      ];
      this.signatureImg = "";
      this.batchVisible = true;
    },
    showReportListBatch() {
      if (this.reportListSelectedRows.length === 0) {
        return this.message(1, "请选择要生成日报的报告");
      }
      this.isReportListBatch = true;
      this.showBatchDateRange = false;
      this.reportListDateList = this.reportListSelectedRows
        .map((row) => row.confirmTime)
        .filter((date) => date)
        .sort();
      this.signatureImg = "";
      this.batchVisible = true;
    },
    batchSubmit() {
      if (this.isReportListBatch) {
        return this.batchSubmitForReportList();
      }
      this.confirmBatchSubmit(() => {
        if (!this.batchDateRange || this.batchDateRange.length !== 2) {
          this.message(1, "请选择日期范围");
          return;
        }
        const [startDate, endDate] = this.batchDateRange;
        if (startDate > endDate) {
          this.message(1, "开始日期不能大于结束日期");
          return;
        }
        const list = this.selectedList.filter((item) => !item.reportId);
        const jobNumList = list.map((item) => item.jobNum);
        if (jobNumList.length === 0) {
          this.message(1, "所选报告都已确认！");
          return;
        }
        if (!this.signatureImg) {
          this.message(1, "请先进行手写签名");
          return;
        }
        this.doBatchSubmit(jobNumList, startDate, endDate);
      });
    },
    batchSubmitForReportList() {
      this.confirmBatchSubmit(() => {
        if (this.reportListSelectedRows.length === 0) {
          this.message(1, "请选择要生成日报的报告");
          return;
        }
        if (!this.reportListRow.jobNum) {
          this.message(1, "工号不存在");
          return;
        }
        if (!this.signatureImg) {
          this.message(1, "请先进行手写签名");
          return;
        }
        const jobNumList = [this.reportListRow.jobNum];
        const dateList = this.reportListSelectedRows
          .map((row) => row.confirmTime)
          .filter((date) => date)
          .sort();
        this.doBatchSubmit(jobNumList, null, null, dateList);
      });
    },
    confirmBatchSubmit(callback) {
      this.$confirm("提交后将覆盖草稿数据，是否确认提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          callback();
        })
        .catch(() => {});
    },
    onSignConfirm(img) {
      this.signatureImg = img;
    },
    doBatchSubmit(jobNumList, startDate, endDate, dateList) {
      this.batchLoading = true;
      const formData = new FormData();
      for (const jobNum of jobNumList) {
        formData.append("jobNumList", jobNum);
      }
      if (this.isReportListBatch && dateList) {
        dateList.forEach((date) => {
          formData.append("dateList", date);
        });
      } else {
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);
      }
      const signFile = this.dataURLtoFile(this.signatureImg, "signature.png");
      formData.append("signature", signFile);
      this.$http
        .post(this.$apiConfig.batch_save_elevator_inspection_report, formData)
        .then((response) => {
          this.batchLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.$message.success("生成成功！");
            this.signatureImg = "";
            this.batchVisible = false;
            this.isReportListBatch = false;
            if (this.reportListVisible) {
              this.getReportList();
            }
          } else if (result.data) {
            const failures = result.data.failure;
            const exists = result.data.exist;
            let failureMsg = failures.length
              ? `有${failures.length}份报告生成失败`
              : "";
            let existMsg = exists.length
              ? `有${exists.length}份报告已存在`
              : "";
            if (failureMsg && existMsg) {
              this.message(1, `${existMsg},${failureMsg}`);
            } else if (failureMsg) {
              this.message(1, `${failureMsg}`);
            } else if (existMsg) {
              this.message(1, `${existMsg}`);
            }
            this.batchVisible = false;
            this.isReportListBatch = false;
            if (this.reportListVisible) {
              this.getReportList();
            }
          } else {
            this.message(result.code, result.msg);
            this.isReportListBatch = false;
          }
        })
        .catch((error) => {
          this.batchLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
          this.isReportListBatch = false;
        });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      const n = bstr.length;
      const u8arr = new Uint8Array(n);
      for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      return new File([u8arr], filename, { type: mime });
    },
    cityFormatter(row) {
      const city = row.city;
      if (!city) {
        return "";
      } else {
        return this.$l(city);
      }
    },
    elevatorTypeFormatter(row) {
      return this.$l(row.elevatorType);
    },
    showWhiteList() {
      this.whiteListVisible = true;
      this.whiteListLoading = false;
      this.$http
        .get(this.$apiConfig.get_elevator_inspection_white_list)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.whiteListData =
              result.data && result.data.length > 0
                ? result.data.map((item) => ({
                    userName: item.userName,
                    telNum: item.telNum,
                  }))
                : [{ userName: "", telNum: "" }];
          } else {
            this.whiteListData = [{ userName: "", telNum: "" }];
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.whiteListData = [{ userName: "", telNum: "" }];
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    addWhiteListRow() {
      this.whiteListData.push({ userName: "", telNum: "" });
    },
    removeWhiteListRow(index) {
      this.whiteListData.splice(index, 1);
    },
    saveWhiteList() {
      const hasEmptyUserName = this.whiteListData.some(
        (item) => item.userName.trim() === ""
      );
      if (hasEmptyUserName) {
        return this.message(1, "用户名不能为空！");
      }
      const userNames = this.whiteListData.map((item) => item.userName.trim());
      const telNums = this.whiteListData
        .map((item) => item.telNum.trim())
        .filter((t) => t);
      const hasDuplicateUserName = new Set(userNames).size !== userNames.length;
      if (hasDuplicateUserName) {
        return this.message(1, "用户名不能重复！");
      }
      const hasDuplicateTelNum = new Set(telNums).size !== telNums.length;
      if (hasDuplicateTelNum) {
        return this.message(1, "手机号不能重复！");
      }
      const validData = this.whiteListData.filter(
        (item) => item.userName.trim() !== ""
      );
      this.whiteListLoading = true;
      this.$http
        .post(this.$apiConfig.save_elevator_inspection_white_list, validData)
        .then((response) => {
          let result = response.data;
          this.whiteListLoading = false;
          if (result.code == 0) {
            this.whiteListVisible = false;
            this.$message.success("保存成功！");
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.whiteListLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  activated() {
    if (this.$refs.filterTable) {
      this.$refs.filterTable.doLayout();
    }
    if (sessionStorage.getItem("reportListDialogOpen") === "true") {
      sessionStorage.removeItem("reportListDialogOpen");
      this.reportListVisible = true;
    }
    const savedInfo = sessionStorage.getItem("elevator_report_list_info");
    if (savedInfo) {
      const info = JSON.parse(savedInfo);
      sessionStorage.removeItem("elevator_report_list_info");
      if (info.openReportList && info.jobNum) {
        this.batchDateRange =
          info.startTime && info.endTime ? [info.startTime, info.endTime] : [];
        this.batchVisible = true;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.lift {
  .dialog-form {
    .el-input,
    .el-select,
    .el-textarea {
      width: 400px;
    }
  }

  .qrcode {
    /deep/ .el-dialog__body {
      padding: 30px 20px 0px 20px;
    }
  }

  .setting-toolbar {
    margin-bottom: 10px;
  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    cursor: pointer;
    fill: #df4545;
  }
}

.report-list-filter {
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;

  /deep/ .el-select .el-input__icon {
    line-height: 39px;
  }

  /deep/ .el-select .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

.dialog-pagination {
  text-align: right;
  padding-top: 15px;
}

.report-list-icon {
  cursor: pointer;
  fill: #30c9c9;
  width: 20px;
  height: 20px;
}

.batch-form {
  padding: 10px 0;

  /deep/ .el-form-item {
    margin-bottom: 0;

    .el-form-item__label {
      line-height: 32px;
    }

    .el-form-item__content {
      margin-left: 8px;
      line-height: 32px;
    }
  }

  /deep/ .el-form-item:last-child {
    margin-top: 10px;
  }
}

.sign-form-item {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
    line-height: normal !important;
  }
}

.sign-display {
  display: flex;
  align-items: center;
  gap: 16px;

  .sign-img {
    max-height: 60px;
    max-width: 200px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
}

.dialog-footer {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}
</style>
